import {
  IManagerLegacyNavTranslations,
  IEventManagerHomeTranslations,
  IEventManagerExhibitorsTranslations,
  IEventManagerProductsTranslations,
  IEventManagerSessionsTranslations,
  IEventManagerExportsTranslations,
  IEventManagerEventsTranslations,
  IManagerTranslations,
} from '@/translations/default/managers';

const legacy_nav: Partial<IManagerLegacyNavTranslations> = {
  product_form: 'Formulario de oferta de empleo',
  product_list: 'Listados de trabajo',
  product_categories: 'Categorías de ofertas de empleo',
};

const home: Partial<IEventManagerHomeTranslations> = {
  products_subtitle: 'Número de ofertas de empleo creadas',
};

const exhibitors: Partial<IEventManagerExhibitorsTranslations> = {
  products_limit_label: 'Límite de trabajo',
  products_limit_message: 'Número máximo de trabajos que puede crear este expositor',
};

const products: Partial<IEventManagerProductsTranslations> = {
  empty_list_form_subtitle: 'Crear el formulario de oferta de empleo',
  empty_list_categories_subtitle: 'Añadir categorías de trabajo',
  empty_list_product_title: 'Oferta_de_trabajo',
  empty_list_product_subtitle: 'Crear una nueva oferta de trabajo',
  title: 'Ofertas de empleo disponibles',
  subtitle: 'Número de ofertas de empleo creadas',
};

const sessions: Partial<IEventManagerSessionsTranslations> = {
  // leave empty until needed
};

const exports: Partial<IEventManagerExportsTranslations> = {
  // leave empty until needed
};

const events: Partial<IEventManagerEventsTranslations> = {
  // leave empty until needed
};

const managers: DeepPartial<IManagerTranslations> = {
  legacy_nav,
  home,
  exhibitors,
  products,
  sessions,
  exports,
  events,
};

export default managers;
